/**
 * Public site origin for absolute URLs (OG tags, share links, email links).
 * `NEXT_PUBLIC_SITE_URL` must match the deployed SPA origin (same as backend `WEBSITE_URL`).
 * Inlined at build time — set it in CI / `.env` before `next build`.
 */
export function resolveSiteOriginString(): string {
  const configured = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  if (configured) return configured.replace(/\/$/, '');
  const vercel = process.env.VERCEL_URL?.trim();
  if (vercel) return `https://${vercel.replace(/\/$/, '')}`;
  return 'http://localhost:3000';
}

/** For Next.js `metadataBase` — trailing slash required. */
export function resolveSiteMetadataBase(): URL {
  return new URL(`${resolveSiteOriginString()}/`);
}
